<template>
  <div class="page-container">
    <Sidebar />
    <div class="main-content">
      <AdminTable :apiEndpoint="'/api/admin/uploaded-files'" :columns="columns" :filters="filters" :formFields="formFields" title="上传文件" />
    </div>
  </div>
</template>

<script>
import AdminTable from '@/components/AdminTable.vue'
import Sidebar from '../components/Sidebar.vue'

export default {
  name: 'UploadedFilesList',
  components: { AdminTable, Sidebar },
  data() {
    return {
      columns: [
        { key: 'id', label: 'ID' },
        { key: 'filename', label: '文件名' },
        { key: 'file_size', label: '大小' },
        { key: 'created_at', label: '时间', type: 'date' }
      ],
      filters: [],
      formFields: [
        { key: 'filename', label: '文件名', type: 'text', required: true },
        { key: 'file_url', label: '文件URL', type: 'text', required: true },
        { key: 'file_size', label: '大小', type: 'text' }
      ]
    }
  }
}
</script>

<style scoped>
.page-container {
  display: flex;
  min-height: 100vh;
}
.main-content {
  margin-left: 260px;
  flex: 1;
  padding: 30px;
  background: #f5f5f5;
}
</style>
